export default "__VITE_ASSET__0a15a748__"